export default {
  setShowSideMenu(state, payload) {
    if (payload) {
      state.sidebarHasOpened = true;
    }
    state.showSideMenu = payload;
  },
  setShowImageGallery(state, payload) {
    state.showImageGallery = payload;
  },
  setActiveExclusiveToolName(state, payload) {
    state.activeExclusiveToolName = payload;
  },
  setShowMiniDrawer(state, payload) {
    state.showMiniDrawer = payload;
  },
  setShowInfoMenu(state, payload) {
    state.showInfoMenu = payload;
  },
  addElevationProfile(state, geometry) {
    state.elevationProfiles.push(geometry);
  },
  setSelectedTheme(state, payload) {
    state.selectedTheme = payload;
  },
  setExplorerVisible(state, payload) {
    state.explorerVisible = payload;
  },
  setCoordinatesVisible(state, payload) {
    state.coordinatesVisible = payload;
  },
  setDrawingActive(state, payload) {
    state.drawingActive = payload;
  },
  setMeasureActive(state, payload) {
    state.measureActive = payload;
  },
  setShowTabs(state, payload) {
    if (payload) {
      state.mapHeight = 50;
      state.bottomTabsHeight = 50;
    }
    state.showTabs = payload;
  },
  setHideWelcomeDialog(state, payload) {
    state.hideWelcomeDialog = payload;
  },
  setHide3dNavigationHelpDialog(state, payload) {
    state.hide3dNavigationHelpDialog = payload;
  },
  setSettingsDialogActive(state, payload) {
    state.settingsDialogActive = payload;
  },
  // setUseDarkMode(state, payload) {
  //   state.useDarkMode = payload;
  // },
  addVisibleTool(state, payload) {
    state.visibleTools.push(payload);
  },
  setPhotoStreamIsActivated(state, photoStreamIsActivated) {
    state.photoStreamIsActivated = photoStreamIsActivated;
  },
  setLogoImagePath(state, newLogoImagePath) {
    state.logoImagePath = newLogoImagePath;
  },
  setLayersAreLoading(state, layersAreLoading) {
    state.layersAreLoading = layersAreLoading;
  },
  removeVisibleTool(state, payload) {
    state.visibleTools.push(payload);
  },
  deactivateTool(state, payload) {
    if (payload) {
      state.tools[payload].active = false;
    }
  },
  activateTool(state, payload) {
    if (payload) {
      state.showLayerInfoCard = false;
      state.tools[payload].active = true;
    }
  },
  setBottomTabsHeight(state, payload) {
    state.bottomTabsHeight = payload;
  },
  setMapHeight(state, payload) {
    state.mapHeight = payload;
  },
  setUserAccount(state, userAccount) {
    state.userAccount = userAccount;
  },
  setUserIsLoggedIn(state, userIsLoggedIn) {
    state.userIsLoggedIn = userIsLoggedIn;
  },
  setUserLoginFailed(state, userLoginFailed) {
    state.userLoginFailed = userLoginFailed;
  },
  setCurrentOrientation(state, payload) {
    state.currentOrientation = payload;
  },
  setShowAppDrawer(state, payload) {
    state.showAppDrawer = payload;
  },
  setLayerDefinitionExpression(state, payload) {
    state.layerDefinitionExpressions[payload.id] = payload;
  },
  setMapLoaded(state) {
    state.mapLoaded = true;
  },
  setSelectedMapProfile(state, payload) {
    state.selectedMapProfile = payload;
  },
  setShowPopupsOnClick(state, payload) {
    state.showPopupsOnClick = payload;
  },
  setImageGalleryItems(state, payload) {
    state.imageGalleryItems = payload;
  },
  clearImageGalleryItems(state) {
    state.imageGalleryItems = [];
  },
  setMapView(state, payload) {
    state.view = payload;
  },
  setIs3d(state, payload) {
    state.is3d = payload;
  },
  addGraphicsLayer(state, graphicsLayer) {
    state.graphicsLayers.push(graphicsLayer);
  },
  addBottomSheet(state, payload) {
    state.tabsAreOpen = true;
    state.bottomSheets.push(payload);
  },
  removeFeatureTable(state, index) {
    state.bottomSheets.splice(index, 1);

    if (state.bottomSheets.length === 0) {
      state.tabsAreOpen = false;
    }
  },
  setCopiedGeometry(state, geometry) {
    state.copiedGeometry = geometry;
  },
  addMetadata(state, payload) {
    state.layerMetadata.push(payload);
  },
  addLayerInfo(state, payload) {
    state.layerInfos.push(payload);
  },
  setExtent(state, payload) {
    state.extent = payload;
  },
  setFavourites(state, payload) {
    state.favourites = payload;
  },
  setBuildingsLayerAdded(state, payload) {
    state.buildingsLayerAdded = payload;
  },
  addFavourite(state, payload) {
    state.favourites.push(payload);
    localStorage.setItem("favourites", JSON.stringify(state.favourites));
  },
  removeFavourite(state, payload) {
    let index = state.favourites.indexOf(payload);

    if (index > -1) {
      state.favourites.splice(index, 1);

      localStorage.setItem("favourites", JSON.stringify(state.favourites));
    }
  },
  setStartupDialog(state, startupDialog) {
    state.startupDialog = startupDialog;
  },
  setZoom(state, payload) {
    state.zoom = payload;
  },
  setSelectedExtent(state, payload) {
    state.selectedExtent = payload;
  },
  addProfile(state, payload) {
    state.addedProfiles.push(payload);
  },
  addMapProfile(state, payload) {
    state.mapProfiles.push(payload);
  },
  REMOVE_MAP_PROFILE_FROM_STATE(state, payload) {
    let index = state.mapProfiles.findIndex(profile => profile.id === payload);
    state.mapProfiles.splice(index, 1);
  },
  setTheMap(state, payload) {
    state.theMap = payload;
  },
  setTheMapView(state, payload) {
    state.theMapView = payload;
  },
  setGuideIsRunning(state, payload) {
    state.guideIsRunning = payload;
  },
  toggleProfileOpen(state, payload) {
    payload.open = !payload.open;
  },
  setProfileVisibility(state, payload) {
    let mapProfileIndex = state.mapProfiles.findIndex(profile => {
      return profile.id == payload.profile.id;
    });
    state.mapProfiles[mapProfileIndex].visible = payload.visible;
  },
  setProfileActualVisibleSublayers(state, payload) {
    state.profiles[payload.id].actualVisibleLayers = payload.VisibleLayers;
  },
  setMapProfileOpacity(state, payload) {
    state.mapProfiles[payload.mapProfileIndex].opacity = payload.opacity;
  },
  updateMapProfiles(state, payload) {
    state.mapProfiles = payload;
  },
  updateMapProfile(state, updateInfo) {
    state.mapProfiles[updateInfo.index] = updateInfo.newProfile;
  },
  setMapProfileDate(state, updateInfo) {
    state.mapProfiles[updateInfo.index].date = updateInfo.newDate;
  },
  updateMapProfileName(state, updateInfo) {
    state.mapProfiles[updateInfo.index].appTitle = updateInfo.newTitle;
  },
  updateMapProfileDescription(state, updateInfo) {
    state.mapProfiles[updateInfo.index].Temaforklaring =
      updateInfo.Temaforklaring;
  },
  setSelectedBasemap(state, payload) {
    state.selectedBasemap = payload.basemap;
    if (state.theMap) {
      state.theMap.basemap = payload.loadedBasemap;
      // let el = state.theMap.ground.layers.items[0];
    }
  },
  setProfiles(state, profiles) {
    state.profiles = profiles;
  },
  setCurrentlyOpenedProject(state, project) {
    state.currentlyOpenedProject = project;
  },
  setSnack(state, snack) {
    state.snackTimeout = 6000;
    state.snackLoading = false;
    state.snack = snack;
  },
  setLoadingSnack(state, snack) {
    state.snackTimeout = 0;
    state.snackLoading = true;
    state.snack = snack;
  },
  setShowCatalogue(state, showCatalogue) {
    state.showCatalogue = showCatalogue;
  },
  setShowPredefinedBookmarks(state, showPredefinedBookmarks) {
    state.showPredefinedBookmarks = showPredefinedBookmarks;
  },
  setPrintWidth(state, newPrintWidth) {
    state.selectedPrintWidth = newPrintWidth;
  },
  setPrintHeight(state, newPrintHeight) {
    state.selectedPrintHeight = newPrintHeight;
  },
  setSelectedPrintScale(state, newPrintScale) {
    state.selectedPrintScale = newPrintScale;
  },
  setSelectedPageFormat(state, newPageFormat) {
    state.selectedPageFormat = newPageFormat;
  },
  setCurrentMapScale(state, newMapScale) {
    state.currentMapScale = newMapScale;
  },
  setSaveIsEnabled(state, saveIsEnabled) {
    state.saveIsEnabled = saveIsEnabled;
  },
  addLastVisitedMap(state, lastVisitedMap) {
    state.lastVisitedMaps.push(lastVisitedMap);
    localStorage.setItem(
      "lastVisitedMaps",
      JSON.stringify(state.lastVisitedMaps).toLowerCase()
    );
  },
  removeLastVisitedMap(state, lastVisitedMap) {
    let index = state.lastVisitedMaps.findIndex(visitedMap => {
      return lastVisitedMap.id === visitedMap.id;
    });

    if (index > -1) {
      state.lastVisitedMaps.splice(index, 1);

      localStorage.setItem(
        "lastVisitedMaps",
        JSON.stringify(state.lastVisitedMaps)
      );
    }
  },
  setPopupVisible(state, popupVisible) {
    state.popupVisible = popupVisible;
  },
  setUserSetting(state, userSetting) {
    state.userSettings[userSetting.id] = userSetting.value;
    localStorage.setItem("nveUserSettings", JSON.stringify(state.userSettings));
  },
  setUserSettings(state, userSettings) {
    state.userSettings = userSettings;
    localStorage.setItem("nveUserSettings", JSON.stringify(state.userSettings));
  },
  setLastVisitedMaps(state, lastVisitedMaps) {
    state.lastVisitedMaps = lastVisitedMaps;
  },
  setShowLayerInfoCard(state, showLayerInfoCard) {
    state.showLayerInfoCard = showLayerInfoCard;
  },
  setSceneViewLoaded(state, sceneViewLoaded) {
    state.sceneViewLoaded = sceneViewLoaded;
  },
  setMapBookmarks(state, mapBookmarks) {
    state.mapBookmarks = mapBookmarks;
    localStorage.setItem("nveMapBookmarks", JSON.stringify(state.mapBookmarks));
  },
  addMapBookmark(state, mapBookmark) {
    state.mapBookmarks.push(mapBookmark);
    localStorage.setItem("nveMapBookmarks", JSON.stringify(state.mapBookmarks));
  },
  editBookmarkTitle(state, bookmarkEditInfo) {
    state.mapBookmarks[bookmarkEditInfo.index].title =
      bookmarkEditInfo.newTitle;
    localStorage.setItem("nveMapBookmarks", JSON.stringify(state.mapBookmarks));
  },
  removeMapBookmark(state, mapBookmarkIndex) {
    state.mapBookmarks.splice(mapBookmarkIndex, 1);
    localStorage.setItem("nveMapBookmarks", JSON.stringify(state.mapBookmarks));
  },
  setIsConnectedToIntranet(state, isConnectedToIntranet) {
    state.isConnectedToIntranet = isConnectedToIntranet;
  },
  setShowHovedforklaring(state, payload) {
    state.showHovedforklaring = payload;
  },
  setMainThemeID(state, payload) {
    state.mainThemeID = payload;
  }
};
